import { render } from "./SimpleKeyboard.vue?vue&type=template&id=34ed3aa4&ts=true"
import script from "./SimpleKeyboard.vue?vue&type=script&lang=ts"
export * from "./SimpleKeyboard.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/democratielab-poster/democratielab-poster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__